<mat-card>
	<mat-card-header>
		<mat-card-title>
			Promoting {{uniqueStudents ? uniqueStudents.length: ''}} Child(ren)
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
		</mat-card-title>
		<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
			<mat-icon>close</mat-icon>
		</button>
	</mat-card-header>

	<mat-card-content>
		<div class="row" *ngIf="!isLoading">
			<div class="col-lg-12">
				<mat-checkbox [color]="'primary'" class="checkbox-margin" [(ngModel)]="removeIneligibleChildren"
					(ngModelChange)="toggleRemoveIneligibleChildren()">
					Remove Ineligible Children</mat-checkbox>
			</div>
		</div>

		<div class="padding-vertical-md row" *ngIf="!isLoading && duplicateStudents && duplicateStudents.length > 0">
			<div>
				<mat-accordion multi>
					<mat-expansion-panel>
						<mat-expansion-panel-header>
							<mat-panel-title>
								{{duplicateStudents.length}} Duplicate Child(ren)
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div class="table-responsive">

							<mat-table [dataSource]="duplicateDataSources[0]" class="mat-elevation-z1">

								<ng-container matColumnDef="SIZE">
									<mat-header-cell *matHeaderCellDef> # </mat-header-cell>
									<mat-cell *matCellDef="let element"> {{element.SIZE}}</mat-cell>
								</ng-container>

								<ng-container matColumnDef="PERSON.LAST_NAME">
									<mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
									<mat-cell *matCellDef="let element"> {{element.PERSON.LAST_NAME |
										titlecase}}{{(element.SECOND_LAST_NAME
										? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}}
										{{element.PERSON.FIRST_NAME |
										titlecase}}
										{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
								</ng-container>

								<ng-container matColumnDef="MSD_NUMBER">
									<mat-header-cell *matHeaderCellDef> MSD Number </mat-header-cell>
									<mat-cell *matCellDef="let element">
										{{element.MSD_NUMBER}}
									</mat-cell>
								</ng-container>


								<mat-header-row *matHeaderRowDef="duplicateDisplayedColumns"></mat-header-row>
								<mat-row *matRowDef="let row; columns: duplicateDisplayedColumns;"></mat-row>
							</mat-table>
						</div>
					</mat-expansion-panel>

				</mat-accordion>
			</div>
		</div>
		<div class="padding-vertical-md row" *ngIf="!isLoading && ineligibleStudents && ineligibleStudents.length > 0">
			<div class="col-lg-12">
				<mat-accordion multi>
					<mat-expansion-panel>
						<mat-expansion-panel-header>
							<mat-panel-title>
								{{ineligibleStudents.length}} Ineligible Child(ren)
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div class="table-responsive">

							<mat-table [dataSource]="ineligibleDataSources[0]" class="mat-elevation-z1">

								<ng-container matColumnDef="PERSON.LAST_NAME">
									<mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
									<mat-cell *matCellDef="let element"> {{element.PERSON.LAST_NAME |
										titlecase}}{{(element.SECOND_LAST_NAME
										? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}}
										{{element.PERSON.FIRST_NAME |
										titlecase}}
										{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
								</ng-container>

								<ng-container matColumnDef="MSD_NUMBER">
									<mat-header-cell *matHeaderCellDef> MSD Number </mat-header-cell>
									<mat-cell *matCellDef="let element">
										{{element.MSD_NUMBER}}
									</mat-cell>
								</ng-container>

								<ng-container
									matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE">
									<mat-header-cell *matHeaderCellDef> EoE Date </mat-header-cell>
									<mat-cell *matCellDef="let element">
										{{element.SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE
										|
										simpleDate}}
									</mat-cell>
								</ng-container>


								<mat-header-row *matHeaderRowDef="ineligibleDisplayedColumns"></mat-header-row>
								<mat-row *matRowDef="let row; columns: ineligibleDisplayedColumns;"></mat-row>
							</mat-table>
						</div>
					</mat-expansion-panel>

				</mat-accordion>
			</div>
		</div>

		<div class="padding-vertical-md" *ngIf="!isLoading">
			<div *ngFor="let school of schools">
				<div class="margin-top-md">
					<h2>{{school.NAME}}</h2>
					<mat-accordion multi>
						<mat-expansion-panel *ngFor="let schoolEnrollment of school.SCHOOL_ENROLLMENTS; let i = index;">
							<mat-expansion-panel-header>
								<mat-panel-title>
									{{getEnabledStudentsCount(schoolEnrollment.STUDENTS) ===
									schoolEnrollment.STUDENTS.length ?
									schoolEnrollment.STUDENTS.length :
									getEnabledStudentsCount(schoolEnrollment.STUDENTS) + '/'
									+ schoolEnrollment.STUDENTS.length}} Child(ren):
									{{schoolEnrollment.currentSchoolYear}} [{{schoolEnrollment.currentGrade}}]
									<mat-icon>keyboard_double_arrow_right</mat-icon>
									{{schoolEnrollment.schoolEnrollmentDetails.SchoolYear}}
									[{{schoolEnrollment.schoolEnrollmentDetails.Grade}}]
								</mat-panel-title>
								<mat-panel-description class="primary">
									Enrollment Type: {{schoolEnrollment.schoolEnrollmentDetails.EnrollmentType}},
									Enrollment
									Date: {{schoolEnrollment.schoolEnrollmentDetails.EnrollmentDate | simpleDate}}
								</mat-panel-description>
							</mat-expansion-panel-header>



							<div>

								<div class="row gx-0">
									<button mat-raised-button color="primary"
										(click)="resolveDialog(schoolEnrollment, school)">
										<mat-icon>edit</mat-icon>
										Resolve Enrollment Details
									</button>

									<mat-form-field class="margin-top-sm">
										<mat-label>
											Enrollment Date
										</mat-label>
										<input matInput
											[(ngModel)]="schoolEnrollment.schoolEnrollmentDetails.EnrollmentDate"
											[matDatepicker]="enrollmentDatePicker" (click)="enrollmentDatePicker.open()"
											startView="multi-year"
											[min]="schoolEnrollment.enrollmentDateOptions.minDate"
											[max]="schoolEnrollment.enrollmentDateOptions.maxDate"
											[required]="schoolEnrollment.schoolEnrollmentDetails.EnrollmentType === 'R'"
											[disabled]="schoolEnrollment.schoolEnrollmentDetails.EnrollmentType === 'N'">
										<mat-datepicker-toggle matSuffix
											[for]="enrollmentDatePicker"></mat-datepicker-toggle>
										<mat-datepicker #enrollmentDatePicker startView="multi-year"
											[startAt]="schoolEnrollment.enrollmentDateOptions.startAt"></mat-datepicker>
									</mat-form-field>

								</div>


								<div class="row"
									*ngIf="schoolEnrollment.endOfEligibilityError && schoolEnrollment.schoolEnrollmentDetails.SchoolYear && schoolEnrollment.lowestEligibleStudent">
									<div>
										<div class="warn-font-color italic">
											{{schoolEnrollment.lowestEligibleStudent.PERSON.FIRST_NAME | titlecase}}
											{{schoolEnrollment.lowestEligibleStudent.PERSON.LAST_NAME | titlecase}}'s
											End of
											Eligiblity date
											{{schoolEnrollment.lowestEligibleStudent.SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE
											| simpleDate}} is ineligiblity for School Year
											{{selectedSchoolYear}}.
										</div>
									</div>
								</div>
								<div class="row"
									*ngIf="schoolEnrollment.hasEnrollmentDateRestriction && schoolEnrollment.schoolEnrollmentDetails.SchoolYear && schoolEnrollment.lowestEligibleStudent">
									<div>
										<div class="warn-font-color italic">
											Enrollment Date's maximum date is set to
											{{schoolEnrollment.lowestEligibleStudent.SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE
											| simpleDate}} because of
											{{schoolEnrollment.lowestEligibleStudent.PERSON.FIRST_NAME |
											titlecase}}
											{{schoolEnrollment.lowestEligibleStudent.PERSON.LAST_NAME | titlecase}}'s
											({{schoolEnrollment.lowestEligibleStudent.MSD_NUMBER}}) End Of Eligibility
											Date.
										</div>
									</div>
								</div>

							</div>
							<div class="table-responsive">
								<mat-table [dataSource]="tableDataSources[schoolEnrollment.INDEX]"
									class="mat-elevation-z1">

									<ng-container matColumnDef="EDIT">
										<mat-header-cell *matHeaderCellDef>
											<button mat-icon-button color="primary"
												(click)="toggleAllStudents(schoolEnrollment)"
												[hidden]="hasAtLeastOneStudent(schoolEnrollment)">
												<mat-icon>check_box_outline_blank</mat-icon>
											</button>
											<button mat-icon-button color="primary"
												(click)="toggleAllStudents(schoolEnrollment)"
												[hidden]="!hasAtLeastOneStudent(schoolEnrollment)">
												<mat-icon>check_box</mat-icon>
											</button>
										</mat-header-cell>
										<mat-cell *matCellDef="let element">
											<button mat-icon-button color="primary"
												(click)="toggleStudent(element, schoolEnrollment)"
												[hidden]="element.ENABLED">
												<mat-icon>check_box_outline_blank</mat-icon>
											</button>
											<button mat-icon-button color="primary"
												(click)="toggleStudent(element, schoolEnrollment)"
												[hidden]="!element.ENABLED">
												<mat-icon>check_box</mat-icon>
											</button>
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="MSD_NUMBER">
										<mat-header-cell *matHeaderCellDef> MSD Number </mat-header-cell>
										<mat-cell *matCellDef="let element">
											{{element.MSD_NUMBER}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="NAME">
										<mat-header-cell *matHeaderCellDef> Child Name </mat-header-cell>
										<mat-cell *matCellDef="let element"> {{element.NAME}} </mat-cell>
									</ng-container>



									<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
									<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
								</mat-table>
							</div>
							<mat-paginator #paginators
								[pageSizeOptions]="[5, 10, 20, (tableDataSources ? tableDataSources[schoolEnrollment.INDEX] ? tableDataSources[schoolEnrollment.INDEX].data.length > 100 ? tableDataSources[schoolEnrollment.INDEX].data.length : 100 : 100 : 100)]"
								showFirstLastButtons aria-label="Select page of periodic elements"
								[hidden]="tableDataSources[i]?.filteredData?.length === 0">
							</mat-paginator>
						</mat-expansion-panel>

					</mat-accordion>
				</div>
			</div>


			<hr />

			<mat-card-actions class="inline">
				<confirm-popover class="margin-bottom-xs" [buttonType]="'string'" [color]="'primary'"
					[popoverMsg]="'Confirm Promote'" [popoverConfirmText]="'Promote'" [buttonTxt]="'Promote'"
					[popoverConfirmColor]="'primary'" (onConfirm)="promote()"
					[disabled]="isSubmitting || (msg && msg.SUCCESS!)">
				</confirm-popover>

				<button type="button" mat-icon-button *ngIf="isSubmitting">
					<mat-icon>
						<mat-spinner diameter="20"> </mat-spinner>
					</mat-icon>
				</button>
			</mat-card-actions>
		</div>
		<app-msg class="margin-left-sm" [msg]="msg" *ngIf="msg?.MSG"></app-msg>
	</mat-card-content>
</mat-card>